export const COPY_VARIATIONS = {
	'copy-version-a': {
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading',
			defaultMessage: "Get help with what you're working on",
			description: 'Heading text for rovo extension install cta left nav',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description',
			defaultMessage: 'Rovo Chat knows your context. Available from any tab.',
			description: 'Description text for rovo extension install cta left nav',
		},
	},
	'copy-version-b': {
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading.copy-version-b',
			defaultMessage: 'Get answers for work, anywhere',
			description: 'Heading text for rovo extension install cta left nav',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description.copy-version-b',
			defaultMessage:
				'Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab.',
			description: 'Description text for rovo extension install cta left nav',
		},
	},
	'copy-version-c': {
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading.copy-version-c',
			defaultMessage: 'Unlock Rovo in every tab',
			description: 'Heading text for rovo extension install cta left nav',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description.copy-version-c',
			defaultMessage: '30K+ workers use it to chat with AI that understands their company.',
			description: 'Description text for rovo extension install cta left nav',
		},
	},
	'copy-version-d': {
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading.copy-version-d',
			defaultMessage: 'Bring Rovo to every tab',
			description: 'Heading text for rovo extension install cta left nav',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description.copy-version-d',
			defaultMessage:
				'Chat with AI that understands your projects and teams. No switching tabs needed.',
			description: 'Description text for rovo extension install cta left nav',
		},
	},
};
